// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"16f9f63b","455":"ea9f1f34","879":"632df913","977":"ef8d6ac8"}[chunkId] + ".chunk.js";
};